export default {
  nextStepsList: [
    {
      order: 1,
      text: "Na de afsluitdatum, die in uw aanbiedingsbrief staat, beginnen wij met het inplannen van de installaties in uw wijk. Wij stemmen een installatiedatum met u af en nemen het installatieplan met u door. De installatieafspraken worden doorgaans 3 á 4 weken van tevoren gepland."
    },
    {
      order: 2,
      text: "In een halve dag wordt het gehele zonnesysteem geïnstalleerd: de zonnepanelen, de omvormer en het kabeltraject, alles wordt vakkundig aangebracht."
    },
    {
      order: 3,
      text: "Na de installatie meldt Sungevity het zonnesysteem aan bij de netbeheerder via energieleveren.nl. Zo weet uw energiemaatschappij dat u zelf stroom opwekt. Dit wordt vervolgens verrekend op uw energierekening."
    },
  ]
}